exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles-input-1EpW9C44 {\n  border: 1px solid;\n  padding: 9px 0px;\n}\n\n.styles-TextInput-2rktu69I {\n  border: none;\n  padding: 10px;\n  width: 240px;\n  opacity: 0.5;\n  border-bottom: solid 0.5px #c7c7c7;\n  padding-bottom: 7.5px;\n  text-align: center;\n  outline: none;\n  background: none;\n}\n\n/* Chrome, Safari, Edge, Opera */\n\ninput::-webkit-outer-spin-button, input::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\n\ninput[type=\"number\"] {\n  -moz-appearance: textfield;\n}\n", ""]);

// exports
exports.locals = {
	"input": "styles-input-1EpW9C44",
	"TextInput": "styles-TextInput-2rktu69I"
};